import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const animateServiceCards = (containerRef) => {
  const cards = containerRef.current.querySelectorAll('.card-container');
  
  cards.forEach((card, index) => {
    gsap.fromTo(
      card,
      { 
        autoAlpha: 0, 
        y: 20,
        scale: 0.95
      },
      {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: card,
          start: 'top bottom-=50',
          toggleActions: 'play none none reverse',
        },
        delay: index * 0.2,
      }
    );
  });
};
